const BASE_URL = "https://5dps193u4a.execute-api.us-east-1.amazonaws.com/api-v2";
module.exports = BASE_URL;